<form>
    <div class="title-outer">
        <h2 class="form-title">{{ languageService.languageJSON.ConfigurationList_Title }}</h2>
    </div>

    <div class="form-section-function">
        <div class="flex-col">
            <div class="flex-row">
                <app-multiple-search [searchFields]="configurationFields" [searchByList]="searchByList"
                    (searchByListChange)="onSearchChanged($event)">
                </app-multiple-search>
                <div class="row-to-right">
                    <button type="button" class="button-with-icon"
                        (click)="customizeDropdownVisible=!customizeDropdownVisible"><img
                            src="assets/icons/table-edit.svg" alt="customize table">{{
                        languageService.languageJSON.Global_Customize }}</button>
                    <div class="customize-dropdown" [formGroup]="selectedColumnsGroup"
                        [hidden]="!customizeDropdownVisible">
                        <mat-selection-list formControlName="selectedColumns" class="row-basis" [disableRipple]="true"
                            (selectionChange)="columnsSelectionChanged()" class="panel-customize">
                            <mat-list-option *ngFor="let columnField of configurationAllFields" color="primary"
                                checkboxPosition="before" [value]="columnField.Id">
                                {{ columnField.DisplayName }}
                            </mat-list-option>
                        </mat-selection-list>
                    </div>
                </div>
            </div>
            <div class="flex-row">
                <app-search-badge [searchByList]="searchByList" [listFields]="configurationFields"
                    (searchByListChange)="onSearchChanged($event)"></app-search-badge>
            </div>
        </div>
    </div>

    <div class="form-section table">
        <div class="flex-outer flex-column table">
            <div class="flex-row header">
                <div class="flex-col"
                    [ngClass]="{'medium-col': configurationField.Id==1, 'clickable':configurationField.GroupBy, 'bold':order==configurationField.FieldName}"
                    *ngFor="let configurationField of configurationFields"
                    (click)="setOrder(configurationField.FieldName, configurationField.GroupBy)">
                    {{ configurationField.DisplayName }}
                    <span class="order-icon" *ngIf="order==configurationField.FieldName && !reverse">▼</span>
                    <span class="order-icon" *ngIf="order==configurationField.FieldName && reverse">▲</span>
                </div>
                <div class="flex-col">
                    {{ languageService.languageJSON.Global_Bikes }}
                </div>
                <div class="flex-col">
                </div>
            </div>
            <ng-scrollbar [hidden]="loading" [orientation]="'vertical'">
                <div class="flex-row" *ngFor="let configuration of configurationList | multipleSearchProperty : searchByList
                | orderBy: order: reverse | paginate: { itemsPerPage: itemsPerPage, currentPage: page,  totalItems: totalItems}">
                    <div class="flex-col" [ngClass]="{'medium-col': configurationField.Id==1}"
                        *ngFor="let configurationField of configurationFields">
                        {{ configuration[configurationField.FieldName] }}
                    </div>
                    <div class="flex-col">
                        <a type="button" (click)="viewBikes(configuration)" *ngIf="configuration.BikeCount>0"> 
                        {{configuration.BikeCount + " " + languageService.languageJSON.Global_Bikes }}
                         </a>
                         <span *ngIf="configuration.BikeCount==0">{{configuration.BikeCount + " " + languageService.languageJSON.Global_Bikes }}</span>
                    </div>
                    <div class="flex-col modify-icons">
                        <div class="icon-outer">
                            <img src="assets/icons/eye-look.svg" (click)="viewConfiguration(configuration)" />
                        </div>
                    </div>
                </div>
                <div class="flex-row" *ngIf="(configurationList | multipleSearchProperty : searchByList).length==0 && !loading">
                    <div class="flex-col" *ngIf="!hasAnySearchElement()">{{ languageService.languageJSON.Global_NoItems }}</div>
                    <div class="flex-col" *ngIf="hasAnySearchElement()">{{ languageService.languageJSON.Global_NoResult }}</div>
                </div>
            </ng-scrollbar>
            <app-loading-animation *ngIf="loading"></app-loading-animation>
        </div>
    </div>
    <div class="pagination" *ngIf="!loading">
        <div class="pagination-text">{{ getPaginationText() }}</div>
        <pagination-controls (pageChange)="onPageChangeEvent($event)"></pagination-controls>
    </div>
</form>